import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { InsuranceService } from "../../../../../services/insurance.service";
import { HelpersService } from '../../../../../services/helpers.service';
import { SelectItem } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { Claim } from '../../models/claim.models';

@Component({
  selector: 'app-view-tasks',
  templateUrl: './view-tasks.component.html',
  styleUrls: ['./view-tasks.component.scss', './../view-claims/view-claims.component.scss', '../../css/_shared.scss'],
  providers: [MessageService],
  encapsulation: ViewEncapsulation.None
})


export class ViewTasksComponent implements OnInit {

  public employees: SelectItem[] = [];
  public tasks: any[] = [];
  public cols: any[] = [];
  public showClaim: boolean = false;
  public claimObject: Claim;
  public claimID = 0;

  public selectedScopes: any[] = [];
  public selectedEmployees: any[] = [];

  constructor(
    public insuranceService: InsuranceService,
    public helpersService: HelpersService,
  ) { }

  ngOnChanges(changes) {
    this.refreshList();
  }


  ngOnInit() {

    //this.claimObject = new Claim(0, 0, "", "", 0, "", 0, "", 0, 0, "", 0, 0, new Date(), "", "", "", "", "", "", "", "", [], [], "", "");
    this.selectedScopes = [];

    //this.employees.push({ label: 'Not Assigned', value: 'Not Assigned' })
    this.insuranceService.getPossibleAssignees().subscribe(response => {
      var obj = JSON.parse(response);
      for (var i = 0; i < obj.Employees.length; i++) {
        this.employees.push({ label: obj.Employees[i].Name, value: obj.Employees[i].Name });
        //this.selectedEmployees.push({ label: obj.Employees[i].Name, value: obj.Employees[i].Name });
      }

    });

    this.selectedEmployees.push(this.helpersService.getProfileData().Name + ' ' + this.helpersService.getProfileData().Surname);
    this.refreshList();

    //this.insuranceService.getInsuranceQuoteTasks().subscribe(response => {
    //  var obj = JSON.parse(response);
    //  for (var i = 0; i < obj.Tasks.length; i++) {
    //    if (obj.Tasks[i].Assignee !== "Not Assigned")
    //      this.tasks.push(obj.Tasks[i]);
    //  }
    //});

    this.cols = [
      { field: 'ClaimNumber', header: 'Claim Number', type: "readonly" },
      { field: 'InsuredName', header: 'Insured', type: "readonly" },
      { field: 'Description', header: 'Description', type: "readonly" },
      { field: 'DueDate', header: 'Due Date', type: "readonlyDate" },
      { field: 'Assignee', header: 'Assignee', type: "readonly" },
      { field: 'ClaimID', header: '', type: "action" },
    ];

  }

  public displayClaim(claimID) {
    this.showClaim = true;
    this.claimID = claimID;
  }

  public refreshList() {
    this.tasks = [];

    console.log(this.helpersService.getProfileData())
    console.log(this.selectedEmployees);

    if (this.selectedEmployees.length == 0) {
      this.insuranceService.getInsuranceQuoteTasks().subscribe(response => {
        var obj = JSON.parse(response);
        for (var i = 0; i < obj.Tasks.length; i++) {
          if (obj.Tasks[i].Assignee !== "Not Assigned")
            this.tasks.push(obj.Tasks[i]);
        }
      });
    }
    else {
      this.insuranceService.getInsuranceQuoteTasks().subscribe(response => {
        var obj = JSON.parse(response);
        for (var i = 0; i < obj.Tasks.length; i++) {
          for (var x = 0; x < this.selectedEmployees.length; x++)
            if (obj.Tasks[i].Assignee === this.selectedEmployees[x])
              this.tasks.push(obj.Tasks[i]);
        }
      });
    }
  }

  public refilterList($event, dt) {
    dt.filter($event.value, "Assignee", 'in')

    if (this.selectedEmployees.indexOf($event.itemValue) == -1)
      this.selectedEmployees.push($event.itemValue)
    else
      this.selectedEmployees.splice(this.selectedEmployees.indexOf($event.itemValue), 1);

    this.refreshList();
  }

  onRowSelect(event) {
    console.log(event);
    this.displayClaim(event.data.ClaimID);
  }

  //setClaimObj(response) {

  //  if (response !== "") {
  //    var obj = JSON.parse(response);
  //    for (var i = 0; i < obj.Claims.length; i++) {
  //      this.claimObject = obj.Claims[i];
  //    }
  //    this.claimObject.IncidentDate = new Date(this.claimObject.IncidentDate);
  //  }
  //}

}
